import { onBeforeUnmount } from 'vue';

function useDebounce<T extends (...args: any[]) => void>(fn: T, delay: number) {
  let timeoutId: number | undefined;

  const debounce = (...args: Parameters<T>) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = window.setTimeout(() => {
      fn(...args);
    }, delay);
  };

  // Clear timeout when the component unmounts to avoid memory leaks
  onBeforeUnmount(() => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  });

  return debounce;
}

export default useDebounce;

